import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from './context/UserContext';
import { BrowserRouter } from 'react-router-dom';
import { CarritoProvider } from './context/CarritoContext';
import {PayPalScriptProvider} from "@paypal/react-paypal-js";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <UserProvider>
            <CarritoProvider>
                <PayPalScriptProvider
                options={{
                    "client-id": "AVS8yofq2RTVG1vXN-ryP9ApuDXLXLLIpdv2pdGVZPmwLfg8Oj3CPfSpfcEK1NYQhIWUaCbKzLBarQjw"
                }}
            >
                    <App />
			</PayPalScriptProvider>
            </CarritoProvider>
        </UserProvider>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
